import { createSelector } from 'reselect';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const options = {
  name: 'dashboards',
  baseType: 'DASHBOARDS'
};

const metadataApiSelectors = createMetadataAPISelectors(options);

const selectCurrentDashboardId = state => state.dashboards.currentDashboardId;

const emptyDashboard = { title: '', pages: [{ widgets: [] }] };

const allGroups = state => state.groups.byId;

export const selectCurrentDashboard = createSelector(
  metadataApiSelectors.byId,
  selectCurrentDashboardId,
  (byId, currentDashboardId) => (currentDashboardId && byId[currentDashboardId]) || emptyDashboard
);

export const selectDashboardDatetime = state => state.dashboards.dashboardDatetime;
const selectActivePageIndex = state => state.dashboards.activePageIndex;

export const selectActivePage = createSelector(
  selectCurrentDashboard,
  selectActivePageIndex,
  (dashboard, activePageIndex) => dashboard.pages[activePageIndex]
);

export const ignoredActivityTypes = createSelector(
  selectCurrentDashboard,
  dashboard => dashboard.incident_ignored_activity_type_ids || []
);

const selectCurrentDashboardGroupId = createSelector(selectCurrentDashboard, dashboard => dashboard.group_id);

export const selectCurrentDashboardGroup = createSelector(
  selectCurrentDashboardGroupId,
  allGroups,
  (groupId, groupsById) => groupsById[groupId]
);

const emptyArray = [];

// Returns all dashboards for the current group
export const selectGroupDashboards = createSelector(
  selectCurrentDashboardGroupId,
  metadataApiSelectors.values,
  (groupId, accessibleDashboards) => {
    let result = accessibleDashboards.filter(d => d.group_id === groupId);
    // remove all special dashboards that have a tag
    result = result.filter(d => !d.tag);
    // avoid unnecessary rerenders if there are no results
    if (result.length === 0) return emptyArray;
    return result;
  }
);

export const selectTemplates = createSelector(metadataApiSelectors.values, dashboards =>
  dashboards.filter(d => d.system_template)
);

export const dashboardAuthHeader = state => {
  const authToken = state.dashboards.dashboardReadAuthToken;
  if (!authToken) return {};
  return { Authorization: `Bearer ${authToken.access_token}` };
};

// returns the layout of the widgets on the active page, in the format that
// react-grid-layout requires
export const activePageWidgetCoordinates = createSelector(selectActivePage, page => {
  return page.widgets.map(widget => ({
    i: String(widget.id),
    x: widget.position_x,
    y: widget.position_y,
    h: widget.height,
    w: widget.width
  }));
});

export default {
  ...metadataApiSelectors,
  selectDashboardDatetime,
  selectCurrentDashboard,
  selectGroupDashboards,
  selectActivePage,
  activePageWidgetCoordinates,
  selectCurrentDashboardGroup,
  selectTemplates
};
